// Provider for EF_ values of localStorage

export const setCCValues = (access_token: string = '', client_id: string = '', expires_at: string = '') => {
    localStorage.setItem('CC_USER_ID', client_id);
    localStorage.setItem('CC_ACCESS_TOKEN_EXPIRES_AT', expires_at);
};
export const get = (key: string) => {
    return localStorage.getItem(key) || '';
};

export const set = (key: string, value: string) => {
    localStorage.setItem(key, value);
};

export const clear = (key: string) => {
    localStorage.setItem(key, '');
};


export const setJWT = (jwt: string) => {
    localStorage.setItem('CC_JWT', jwt);
};

export const getJWT = () => {
    return localStorage.getItem('CC_JWT') || '';
};

export const clearJWT = () => {
    localStorage.setItem('CC_JWT', '');
};
export const clearPersist = () => {
    localStorage.setItem('persist:root', '');
};
export const clearCCValues = () => {
    localStorage.setItem('CC_JWT', '');
    localStorage.setItem('CC_ANON_JWT', '');
    localStorage.setItem('CC_USER_ID', '');
    localStorage.setItem('CC_ACCESS_TOKEN_EXPIRES_AT', '');
};

export const getCCValues = () => {
    return {
        CC_USER_ID: localStorage.getItem('CC_USER_ID') || '',
        CC_ACCESS_TOKEN_EXPIRES_AT: localStorage.getItem('CC_ACCESS_TOKEN_EXPIRES_AT') || '',
    };
};
